import { tns } from 'tiny-slider/src/tiny-slider';
import whenDomReady from 'when-dom-ready';
function initialise() {
    initStories();
}
function initStories() {
    const stories = document.querySelectorAll('.js-tabbed-stories');
    if (!stories) {
        return;
    }
    stories.forEach((story) => {
        const controls = story.querySelector('.js-tabbed-stories-controls');
        const contents = story.querySelector('.js-tabbed-stories-contents');
        const navItems = story.querySelector('.js-tabbed-stories-nav-items');
        if (!contents || !controls || !navItems) {
            return;
        }
        tns({
            autoplay: false,
            autoplayButtonOutput: false,
            center: true,
            container: contents,
            controls: true,
            controlsContainer: controls,
            gutter: 24,
            loop: false,
            nav: true,
            navContainer: navItems,
            rewind: true,
            items: 1,
            slideBy: 1,
            speed: 500,
        });
    });
}
whenDomReady().then(initialise);
